import normalizeLinkedResourceToObject from './normalizeLinkedResourceToObject';
import memoize from 'lodash.memoize';
import validUrl from 'valid-url';

var normalizeLinkedResources = memoize(function (property) {
  if (!property) {
    return [];
  }
  if (typeof property === 'string') {
    if (!validUrl.isWebUri(property)) {
      return [];
    }
    return [{ '@id': property }];
  }
  if (Array.isArray(property)) {
    return property.map(function (prop) {
      return normalizeLinkedResourceToObject(prop);
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []).filter(function (e) {
      return e;
    });
  }
  return normalizeLinkedResourceToObject(property);
});

export default normalizeLinkedResources;